import { Children, forwardRef, type ReactNode } from "react";
import * as styles from "./styles.css";

interface ColumnsGridProps extends React.HTMLAttributes<HTMLDivElement> {
  columnCount: number;
  gap?: string;
  children: Iterable<ReactNode>;
}

export const ColumnsGrid = forwardRef(
  (
    { columnCount, gap = "10px", children, ...props }: ColumnsGridProps,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    const array: Array<ReactNode> = Array.from(
      { length: columnCount },
      (_) => [],
    );

    Children.forEach(children, (child, index) => {
      const column = array[index % columnCount];
      if (Array.isArray(column)) {
        column.push(child);
      }
    });

    return (
      <div
        ref={ref}
        className={styles.columnsGridContainer}
        style={{ [styles.gapVar]: gap }}
        {...props}
      >
        {array.map((column, index) => {
          return (
            <div key={`column-${index}`} className={styles.column}>
              {column}
            </div>
          );
        })}
      </div>
    );
  },
);

ColumnsGrid.displayName = "ColumnsGrid";
